var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.$style.summary},[_c('IxRes',{attrs:{"context":{
      total: _vm.summary.candidateImages.length,
      cloudy: _vm.summary.candidateImages.filter(function (x) { return x.outcome === 'TooCloudy'; }).length
    }}},[_vm._v("\n    frs.zoneMaps.details.cultivationImageAvailability\n  ")]),_c('NdviLineChart',{attrs:{"ndvi-data":_vm.ndviData}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }